import React from 'react'
import { faAdd, faTrash } from '@fortawesome/free-solid-svg-icons'

import { OrdersContext } from 'contexts/OrdersContext'
import {
  DcButton,
  PixelCurrency,
  PixelDate,
  PixelIcon,
  PixelTag,
  PixelText,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'
import { deletePayment } from 'utils/api-routes.util'

import AddPayments from './subComponents/AddPayments'
import InvoicePaymentsAdd from './subComponents/InvoicePaymentsAdd'
import {
  IPixelFactory,
  OrderDetail,
  PaymentMethod,
  Customer,
} from '../../../../../decl.d'

interface IProps {
  details: OrderDetail
  detailID: number
  setDetails: (details: OrderDetail) => void
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  isItInvoice: boolean
  paymentMethods: PaymentMethod[]
  customerData: Customer
  newPaymentMethod: PaymentMethod
  setCustomerData: (customerData: Customer) => void
}
const OrderPayments = (props: IProps) => {
  const { state } = React.useContext(OrdersContext)

  const {
    showPageLoader,
    hidePageLoader,
    showSuccess,
    showFailure,
    pixelConfirm,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const {
    details,
    detailID,
    setDetails,
    newOrderData,
    setNewOrderData,
    isItInvoice,
    newOrder,
    paymentMethods,
    customerData,
    newPaymentMethod,
    setCustomerData,
  } = props

  const [payments, setpayments] = React.useState<any>([])
  const [addAble, setAddAble] = React.useState(false)
  const [invoicePaymentAdd, setInvoicePaymentAdd] = React.useState(false)
  const handleDeletePayment = (detailID, item_id, payment_method_id) => {
    if (newOrder === true) {
      setNewOrderData({
        ...newOrderData,
        payment_lines: newOrderData?.payment_lines.filter(
          (item, index) => index !== payment_method_id,
        ),
      })
    } else {
      pixelConfirm({
        title: 'Delete Payment',
        message:
          'Are you sure? you want to delete this Payment, This action cannot be undone.',
        onConfirm: () => {
          showPageLoader()

          deletePayment(detailID, item_id).subscribe((res: any) => {
            hidePageLoader()
            if (res.response.error) {
              showFailure(res.response.error)
            } else {
              showSuccess('Successfully Deleted')
              setDetails(res.response.data)
            }
          })
        },
      })
    }
  }

  React.useEffect(() => {
    setpayments(details?.payments)
  }, [details])
  return (
    <Container>
      <InnerSection>
        <SectionHeader>
          <PixelText
            textSize="16px"
            color="rgba(0, 0, 0, 0.84)"
            style={{ fontWeight: '600', padding: '10px' }}
          >
            Payments
          </PixelText>
          {newOrder ? (
            <>
              {!addAble ? (
                <AddPaymentsContainer>
                  <AddPayments
                    detailID={detailID}
                    state={state}
                    newOrderData={newOrderData}
                    setNewOrderData={setNewOrderData}
                    newOrder={newOrder}
                    handleClose={() => {
                      setAddAble(true)
                    }}
                  />
                </AddPaymentsContainer>
              ) : (
                <Headerend>
                  <DcButton
                    variant="link"
                    size="sm"
                    onClick={() => {
                      setAddAble(false)
                    }}
                  >
                    <PixelIcon showTooltip tooltip="Add" icon={faAdd} />
                  </DcButton>
                </Headerend>
              )}
            </>
          ) : (
            <>
              {details?.is_editable === true && (
                <>
                  {addAble ? (
                    <AddPaymentsContainer>
                      <AddPayments
                        detailID={detailID}
                        state={state}
                        newOrderData={newOrderData}
                        setNewOrderData={setNewOrderData}
                        newOrder={newOrder}
                        handleClose={(data) => {
                          setAddAble(false)
                          if (data) {
                            setDetails(data)
                          }
                        }}
                      />
                    </AddPaymentsContainer>
                  ) : (
                    <Headerend>
                      <DcButton
                        variant="link"
                        size="sm"
                        onClick={() => {
                          if (isItInvoice) {
                            setInvoicePaymentAdd(true)
                          } else {
                            setAddAble(true)
                          }
                        }}
                      >
                        <PixelIcon showTooltip tooltip="Add" icon={faAdd} />
                      </DcButton>
                    </Headerend>
                  )}
                </>
              )}
            </>
          )}
        </SectionHeader>
      </InnerSection>
      {/* ------------------------------------------- Invoice Payment AddForm --------------------------------------------------   */}
      {isItInvoice && (
        <>
          {invoicePaymentAdd && (
            <InnerSectionContent>
              <InnerSection>
                <InvoicePaymentsAdd
                  detailID={detailID}
                  paymentMethods={paymentMethods}
                  customerData={customerData}
                  newPaymentMethod={newPaymentMethod}
                  setCustomerData={setCustomerData}
                  details={details}
                  setDetails={setDetails}
                  handleClose={(data) => {
                    if (data) {
                      setDetails({
                        ...details,
                        payments: data?.payments,
                        invoice_balance_amount: data?.invoice_balance_amount,
                        invoice_payment_status: data?.invoice_payment_status,
                        invoice_status: data?.invoice_status,
                      })
                    }
                    setInvoicePaymentAdd(false)
                  }}
                />
              </InnerSection>
            </InnerSectionContent>
          )}
        </>
      )}

      {newOrder ? (
        <>
          <InnerSectionContent>
            {newOrderData?.payment_lines?.length > 0 && (
              // ------------------------- new order -------------------------
              <>
                {newOrderData?.payment_lines?.map((item, index) => {
                  return (
                    <InnerSection key={index}>
                      <PaymentContainer>
                        <PaymentsTitle>
                          <PaymentGateway>{item.gateway_name} </PaymentGateway>
                        </PaymentsTitle>
                        <Amounts>
                          <PixelCurrency value={item.amount} />
                        </Amounts>

                        <Actions>
                          <PixelIcon
                            showTooltip
                            tooltip="Delete"
                            icon={faTrash}
                            color="red"
                            fontSize="1x"
                            onClick={() => {
                              handleDeletePayment(
                                detailID,
                                item?.payment_id,
                                index,
                              )
                            }}
                          />
                        </Actions>
                      </PaymentContainer>
                    </InnerSection>
                  )
                })}
              </>
            )}
          </InnerSectionContent>
        </>
      ) : (
        <InnerSectionContent>
          {payments?.length > 0 && (
            <>
              {payments?.map((item, index) => {
                return (
                  <InnerSection key={index}>
                    <PaymentContainer>
                      <PaymentsTitle>
                        <PaymentGateway>
                          {item.payment_gateway_name}
                        </PaymentGateway>
                        {item.payment_method_type && (
                          <PixelTag>{item.payment_method_type}</PixelTag>
                        )}
                      </PaymentsTitle>

                      <Amounts>
                        <PixelCurrency value={item.amount} />
                        {item.financial_status && (
                          <PaymentStatus
                            color={
                              item.financial_status === 'paid'
                                ? 'green'
                                : item.financial_status === 'refunded'
                                ? 'red'
                                : 'grey'
                            }
                          >
                            {isItInvoice && (
                              <div>
                                {item.created_at && (
                                  <PixelDate
                                    size="12px"
                                    value={item.created_at}
                                    format={'pixelStandard'}
                                  />
                                )}
                              </div>
                            )}
                            &nbsp; &nbsp;
                            {item.financial_status}
                          </PaymentStatus>
                        )}
                      </Amounts>
                      {isItInvoice ? (
                        ''
                      ) : (
                        <>
                          {details?.is_editable === true && (
                            <Actions>
                              <PixelIcon
                                showTooltip
                                tooltip="Delete"
                                icon={faTrash}
                                color="red"
                                fontSize="12x"
                                onClick={() => {
                                  handleDeletePayment(
                                    detailID,
                                    item?.payment_id,
                                    index,
                                  )
                                }}
                              />
                            </Actions>
                          )}
                        </>
                      )}
                    </PaymentContainer>
                  </InnerSection>
                )
              })}
            </>
          )}
        </InnerSectionContent>
      )}
    </Container>
  )
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const InnerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
  padding: 10px 0px;
`
const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const InnerSectionContent = styled.div<{ direction?: boolean; gap?: string }>`
  display: flex;
  flex-direction: ${(props) => (props.direction ? 'row' : 'column')};
  gap: ${(props) => props.gap};
`

const PaymentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  align-content: center;
  width: 100%;
  padding: 10px;
`

const Amounts = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.84);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 35%;
  align-items: flex-end;
`
const PaymentStatus = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: row;
  font-size: 8px;
  color: ${(props) => (props.color && props.color) || 'grey'};
`
const PaymentsTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.84);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 50%;
`
const PaymentGateway = styled.div``
const Headerend = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 15px;
  /* padding: 10px; */
  margin-right: 15px;
  cursor: pointer;
`
const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 9%;
`
const AddPaymentsContainer = styled.div`
  width: 75%;
`

export default OrderPayments
